// @flow
import CheckboxEnableApp from './CheckboxEnableApp'

// types
import type { ProductContent } from '../../Core/Types/ProductContent'
import type { ImmutableType } from '../../Core/Types/ImmutableTypes'
import type { InputHelpType } from '../../Core/Types/InputHelpType'
import type { ExpandedSpecificationDTO } from '../../Core/Types/Field'

export type DefaultMiniAppProps = {
  content: ProductContent,
  formData: Object & ImmutableType,
  data: Object & ImmutableType, // relative data
  inputHelps: InputHelpType,
  isBackOffice: boolean,
  miniAppData: Object,
  onChangeFieldVisibility: (fieldPath: string, hidden: boolean) => void,
  onChangeFormData: (formData: Object & ImmutableType, key?: string, value?: any) => void,
  pushIsPristine: boolean,
  specification?: ExpandedSpecificationDTO,
  validationErrors: { [key: string]: { [key: string]: string } },
}

export default {
  checkboxEnableApp: CheckboxEnableApp
}
